"use client";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";
import ProfileGrid from "../components/profile/ProfileGrid";
import apiEndpoints from "../apiConfig";
import { useToast } from "../contexts/ToastContext";

function RequestedEnquiries() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  const { showToast } = useToast();
  const prevCount = useRef(0);

  useEffect(() => {
    if (!user) return;

    fetch(`${apiEndpoints.getRequestedEnquiries}?user_id=${user.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          if (data.length === 0 && prevCount.current > 0) {
            showToast("No enquiries found", "info");
          }
          prevCount.current = data.length;

          // Map data to match ProfileGrid structure
          const mappedProfiles = data.map((item) => ({
            id: item.id,
            user_id: item.profile_user_id ?? item.user_id ?? item.id,

            name: item.name,
            age: item.age,
            city: item.city,
            state: item.state,
            country: item.country,
            profession: item.profession,
            education: item.education,
            religion: item.religion,
            profile_photo: item.profile_photo,
            isVerified: item.isVerified,
            lastActive: "Today",
            enquiryStatus: item.status,
            onSendEnquiry: () => {},
          }));
          setProfiles(mappedProfiles);
          const event = new CustomEvent("enquiryCountChanged", {
            detail: { count: mappedProfiles.length },
          });
          window.dispatchEvent(event);
        } else {
          console.error("Expected array but got:", data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching requested enquiries:", err);
        setLoading(false);
      });
  }, [user]);

  const handleViewProfile = (profileId) => navigate(`/profile/${profileId}`);
  const handleAddToWishlist = (profileId) =>
    console.log("Wishlist:", profileId);

  if (loading) {
    return (
      <Container
        maxWidth="xl"
        sx={{ mt: 4, display: "flex", justifyContent: "center" }}
      >
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 4, fontWeight: 700 }}>
        Requested Enquiries
      </Typography>

      <ProfileGrid
        profiles={profiles}
        onViewProfile={handleViewProfile}
        onAddToWishlist={handleAddToWishlist}
        pageType="enquiries"
      />
    </Container>
  );
}

export default RequestedEnquiries;
